// 由原图 URL 推导缩略图 URL：将扩展名替换为 _thumb.jpg
// 与后端 FileUploadUtil.generateThumb 命名规则一致（{原名}_thumb.jpg）
export function thumb(url) {
  if (!url) return url
  const clean = String(url).split('?')[0]
  return clean.replace(/\.(jpe?g|png|gif|webp|bmp)$/i, '_thumb.jpg')
}

// 缩略图加载失败时回退到原图，避免白屏（存量图尚未生成缩略图时）
export function onImgError(e) {
  const img = e.target
  if (!img) return
  const orig = img.getAttribute('data-orig')
  if (orig && img.src.indexOf('_thumb') === -1) {
    img.src = orig
  }
}
